import React from 'react'
import '../../styles/homescreen.css'

export const HomeScreen = () => {
  return (

    <div className="homeContainer">

      <h2 className="homeContainer__title">Un poco sobre mí:</h2>
      <div className="homeContainer__hi">Estoy en la búsqueda de mi primera oportunidad como programador front-end conocí la programación web y enseguida me hizo clic; A pesar de siempre estar ligado al mundo de la computación fue orientado hacia el hardware, ahora codear sé ha convertido en mi pasión. Me encanta que todos los días pueda aprender algo nuevo y en la actualidad estoy realizando un curso para ser fullstack con el stack MERN, sobre diseño web estoy aprendiendo para desarrollarme de forma profesional, Espero les guste mi página.
        </div>
        <div className="homeContainer__hi">
         ¡Muchas gracias!
        </div>
        <div className="homeContainer__email">
          <div>Contactos:</div> 
          <div>heliosoto17@gmail.com</div>
        </div>
        <div className="homeContainer__contact">
          <a className="homeContainer__contact-a" target="_blank" href="https://www.facebook.com/helio.soto.5/"> 
          <i className="fab fa-facebook-square"></i>
          </a>
          <a target="_blank" href="https://github.com/Heliosoto1987">
          <i className="fab fa-github-square"></i>
          </a>
          <a target="_blank" href="https://www.linkedin.com/in/helio-javier-soto-arevalo-78b9261b9/"> 
          <i className="fab fa-linkedin"></i>
          </a>
         
        </div>

    </div>


  )
}
